import {
  choferPartialBuilder,
  ChoferPartialModel
} from 'app/chofer/models/Chofer';
import {
  transferReservationPartialBuilder,
  TransferReservationPartialModel
} from '../../viajeTraslado/models/TransferReservationPartial';

export interface TransferReservationOpenedModel
  extends TransferReservationPartialModel {
  assigned_driver: ChoferPartialModel;
  semaphore: {
    color: string;
    order: number | undefined;
  };
  is_contingency: boolean;
}

export const transferReservationOpenedBuilder = {
  fromBackEnd: (reservation): TransferReservationOpenedModel => ({
    ...transferReservationPartialBuilder.fromBackEnd(reservation),
    assigned_driver: choferPartialBuilder.fromBackEnd(
      reservation.assigned_driver
    ),
    semaphore: {
      color: reservation.semaphore?.color?? '',
      order: reservation.semaphore?.order ?? undefined
    },
    is_contingency: reservation.is_contingency ?? false
  })
};
